module.exports = __webpack_public_path__ + "static/media/map_tecture.7cee22f9.png";